import React from "react";
import { Container, Button } from "shards-react";

export default class TokenExpiired extends React.Component{

  constructor(){
    super()
  }

  async componentDidMount(){
    setTimeout(() => this.handleRedirect(), 3000)
  }

  handleRedirect = () => {
    window.location.href='/login'
  }

  render(){
    return (
      <Container fluid className="main-content-container px-4 pb-4">
        <div className="error">
          <div className="error__content">
            <h2>El token expiró</h2>
            <p>Será redirigido al login en pocos segundos</p>
            <Button pill href="/login">&larr; Ir a login</Button>
          </div>
        </div>
      </Container>
    )
  }
}  

